import AdminUserCreateView from "./AdminUserCreateView";
import useAdminUserCreateModel from "./useAdminUserCreateModel";

const AdminUserCreatePage = () => {
  const model = useAdminUserCreateModel();
  return <AdminUserCreateView {...model} />;
};

export default AdminUserCreatePage;
